export const paths = {
  Pagina: 'Pagina',
  IniciarSesionRemision: 'Pagina/IniciarSesionRemision',
  Remision: 'Remision',
  Contactenos: 'Contactenos',
  Seguimiento: 'Seguimiento',
  Connect: 'Connect',
  Sistema: 'Sistema',
  Extensiones: 'Extensiones',
};
